const actions = {
  SET_STATE: 'eshop/SET_STATE',
  GET_GIFTS: 'eshop/GET_GIFTS',
  REDEEM_GIFTS: 'eshop/REDEEM_GIFTS',
}

export default actions
